export const notes = {
  0: {
    name: "Tetrachords",
    notes: [
      ["E2", "F3", "G3", "Db3", "F3"],
      ["Gb3", "Eb3", "Ab3", "D4", "Ab4"],
      ["B4", "C4", "A4", "Bb5", "A5"],
      ["B5", "C5", "A5", "Bb6", "A6"]
    ]
  },
  1: {
    name: "Octave Jumper",
    notes: [
      ["C2", "C3", "C4", "C5", "C6"],
      ["G3", "G4", "G5", "F3", "F4"],
      ["E3", "E4", "E5", "A3", "A4"],
      ["A5", "F5", "A5", "F5", "A5"]
    ]
  },
  2: {
    name: "Dreamy",
    notes: [
      ["C3","D3","E3","F#3","G#3"],
      ["A#4","C4","D4","E4","F#4"],
      ["G#4","A#5","C5","D5","E5"],
      ["F#5","G#5","A#6","C6","D6"]
    ]
  },
  3: {
    name: "Trichords",
    notes: [
      ["E2", "F2", "C#2", "E2", "F2"],
      ["Eb3", "C3", "D3", "Eb3", "C3"],
      ["G#4", "A4", "Bb4", "G#4", "A4"],
      ["F#5", "G5", "B5", "F#5", "G5"]
    ]
  },
  4: {
    name: "Pentatonic",
    notes: [
      ["C3", "D3", "E3", "F#3", "G#3", "A#3"],
      ["C4", "D4", "E4", "F#4", "G#4", "A#4"],
      ["C5", "D5", "E5", "F#5", "G#5", "A#5"],
      ["C6", "D6", "E6", "F#6", "G#6", "A#6"]
    ]
  },
  5: {
    name: "Happy",
    notes: [
      ["C3", "E3", "D3", "E3", "D3"],
      ["G4", "F#4", "G4", "F#4", "G4"],
      ["B5", "D5", "A5", "B5", "A5"],
      ["B6", "D6", "A6", "B6", "A6"]
    ]
  }
};



// WEBPACK FOOTER //
// ./frontend/components/sequencer/notes.jsx